module.exports = __webpack_public_path__ + "img/Exemplo_de_estrutura.f365f856.png";